import { ChartAssetData } from '@toggle/chart';

export const filterByDateRange = <T extends { time: string }>(
  items: T[],
  startDate: Date,
  endDate: Date
): T[] => {
  const startTime = startDate.getTime();
  const endTime = endDate.getTime();
  return items.filter(item => {
    const itemTime = new Date(item.time).getTime();
    return itemTime >= startTime && itemTime <= endTime;
  });
};

export const getCommonDateRange = (chartData: ChartAssetData[]) => {
  const ranges = chartData
    .filter(asset => asset.ts.length > 0)
    .map(asset => ({
      start: new Date(asset.ts[0].time),
      end: new Date(asset.ts[asset.ts.length - 1].time),
    }));

  if (!ranges.length) {
    return null;
  }

  const startTime = Math.max(...ranges.map(r => r.start.getTime()));
  const endTime = Math.min(...ranges.map(r => r.end.getTime()));

  if (startTime > endTime) {
    return null;
  }

  return {
    start: new Date(startTime),
    end: new Date(endTime),
  };
};
